import { SessionSiteSelectors } from '~src/app/selectors/SessionInfoSelectors';
import { Messages } from '~src/codegen/Localize';
import { areLinkedTasksEnabled } from '~src/linkedTasks/utils/LinkedTaskHelpers';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { FeatureFlags } from '~src/ts/FeatureFlags';
import { IManageFlowAction } from '~src/ts/ServerApi/types/actionNames';

import { scheduleLinkedTaskAction } from '../actions/ScheduleLinkedTaskAction';
import { scheduleSingleFlowTaskAction } from '../actions/ScheduleSingleFlowTaskAction';

export const ScheduleSingleFlowTaskEntityAction: IEntityAction<IContentInfo<'flow'>, IManageFlowAction> = {
  name: EntityActionNames.ScheduleSingleFlowTask,
  translateName: Messages.scheduleSingleTaskAction,
  isVisible: () => true,
  isClickable: (availableActions, targetItems, state) => !!availableActions && availableActions.manageFlow && SessionSiteSelectors.schedulingFlowsEnabled(state),
  createReduxAction: (items: IContentInfo[]) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('scheduleSingleFlowTaskAction was called without exactly one item');
    }
    return scheduleSingleFlowTaskAction(items[0]);
  }
};


export const ScheduleLinkedTaskEntityAction: IEntityAction<IContentInfo<'flow'>, IManageFlowAction> = {
  name: EntityActionNames.ScheduleLinkedTask,
  translateName: Messages.scheduleLinkedTaskAction,
  isVisible: () => areLinkedTasksEnabled(),
  isClickable: (availableActions, targetItems, state) => !!availableActions && availableActions.manageFlow && SessionSiteSelectors.schedulingFlowsEnabled(state),
  createReduxAction: (items: IContentInfo[]) => {
    // TODO 1332820: change this to take items array
    return scheduleLinkedTaskAction(items[0]);
  }
};


export const ScheduleFlowTaskSubmenuEntityAction: IEntityAction<IContentInfo<'flow'>, IManageFlowAction> = {
  name: EntityActionNames.ScheduleFlowTaskSubmenu,
  translateName: Messages.scheduleFlowTaskAction,
  isVisible: (items, state) => FeatureFlags.linkedTasksSP2Enabled && !(items.length > 1 && !areLinkedTasksEnabled()) && (ScheduleSingleFlowTaskEntityAction.isVisible(items, state) || ScheduleLinkedTaskEntityAction.isVisible(items, state)),
  isClickable: (availableActions, targetItems, state) => ScheduleSingleFlowTaskEntityAction.isClickable(availableActions, targetItems, state) || ScheduleLinkedTaskEntityAction.isClickable(availableActions, targetItems, state),
  createReduxAction: () => null // The menu widget doesn't let "submenu" items be clicked
};
